import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  label?: string;
  note?: string;
};
export function Countdown({
  label = "This special offer ends in:",
  note
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    unit: "Hours"
  }, {
    value: minutes,
    unit: "Min"
  }, {
    value: seconds,
    unit: "Sec"
  }];
  return <div className="flex w-full flex-col items-center" role="timer" aria-live="off" data-id="element-23" data-mp="3c3z14y5dj0ca">
      <p className="flex items-center gap-2 text-[13px] font-bold uppercase tracking-wider text-brand-rose" data-id="element-24" data-mp="3h2a9t5jxn4sx">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-25" data-mp="325szmhnhbw7y" />
        {label}
      </p>
      <div className="mt-3 flex items-start gap-2" data-id="element-26" data-mp="373b7e4prg5ed">
        {units.map((u, i) => <React.Fragment key={u.unit} data-id="element-27" data-mp="10dmvdcovu13s" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-28" data-mp="10aina48aql7u">
              <span className="flex h-[68px] w-[72px] items-center justify-center rounded-xl bg-brand-olive font-serif text-4xl font-bold tabular-nums text-cream shadow-[0_8px_18px_-8px_rgba(30,50,25,0.6)] md:h-20 md:w-20 md:text-5xl" data-id="element-29" data-mp="15a50wes1e3h6">
                {u.value}
              </span>
              <span className="mt-1.5 text-[11px] font-semibold uppercase tracking-widest text-ink/60" data-id="element-30" data-mp="17py8l603k3vt">
                {u.unit}
              </span>
            </div>
            {i < units.length - 1 && <span className="pt-4 font-serif text-3xl font-bold text-brand-olive md:pt-5" data-id="element-31" data-mp="f3dkqfity9x0">:</span>}
          </React.Fragment>)}
      </div>
      {note && <p className="mt-3 text-center text-sm text-ink/65" data-id="element-32" data-mp="o2qqoy7qwgcz">{note}</p>}
    </div>;
}